import SimpleDocSelector from "lib/components/common/docs/simple-doc-selector";
import FlexBox from "lib/components/common/flex-box";
import SimpleButton from "lib/components/common/simple-button";
import { FC, useEffect, useState } from "react";

interface PractitionerSignupDocumentsProps {
  practitionerDocs?: PractitionerSignUpDocs;
  isLoading?: boolean;
  isUploading?: boolean;
  onSubmit?: (values: PractitionerSignUpDocs) => void;
}

const PractitionerSignupDocuments: FC<PractitionerSignupDocumentsProps> = ({
  isLoading,
  practitionerDocs,
  isUploading,
  onSubmit,
}) => {
  const [signUpDocs, setSignUpDocs] = useState<PractitionerSignUpDocs | null>(
    practitionerDocs
  );

  useEffect(() => {
    if (practitionerDocs?.profileImageURL || practitionerDocs?.certificateURL) {
      setSignUpDocs({
        ...practitionerDocs,
        profileImageURL: practitionerDocs?.profileImageURL,
        certificateURL: practitionerDocs?.certificateURL,
      });
    }
  }, [practitionerDocs]);

  return (
    <FlexBox
      justifyContent="start"
      alignItems="start"
      direction="column"
      className="w-100"
    >
      <h5 className="mb-0">Select Documents</h5>
      <small className="text-muted">
        Click on the therapies below to remove them
      </small>
      <SimpleDocSelector
        label="Upload your profile image"
        required
        docType="IMAGES"
        docUrl={signUpDocs?.profileImageURL}
        onChange={(files) => {
          setSignUpDocs({ ...signUpDocs, profileImage: files?.[0] });
        }}
      />
      <SimpleDocSelector
        label="Upload your educational certificate"
        required
        docType="DOCUMENTS"
        docUrl={signUpDocs?.certificateURL}
        onChange={(files) => {
          setSignUpDocs({ ...signUpDocs, certificate: files?.[0] });
        }}
      />
      <FlexBox
        justifyContent="center"
        alignItems="center"
        className="w-100 mt-3"
      >
        <SimpleButton
          variant="primary"
          onClick={() => onSubmit?.(signUpDocs)}
          isLoading={isLoading}
          disabled={ isUploading }
        >
          Submit
        </SimpleButton>
      </FlexBox>
      <br />
    </FlexBox>
  );
};
export default PractitionerSignupDocuments;
